<div style="max-width: 700px; margin: auto; text-align: center;">
  <div *ngIf="loading" class="loader">
    Loading...
  </div>

  <div *ngIf="!loading && noData" class="no-data">
    No data
  </div>

  <canvas *ngIf="!loading && !noData"
          #chartCanvas
          style="min-height:300px;">
  </canvas>
</div>
